import React from "react";
import PropTypes from "prop-types";

/**
 * Aux: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Auxiliary helper component to wrap multiple React
 * elements inside one container. Can inherit 'inline' style
 * and 'className' property from props.
 *
 * @param {*} props
 */
const Aux = props => (
  <div
    style={props.inline ? { display: "inline-block" } : {}}
    className={props.className}
  >
    {props.children}
  </div>
);

/**
 * Exports a prop type, where the item can be either a
 * single React node or several
 */
export const NodeOrMultipleNodes = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.node),
  PropTypes.node
]);

Aux.propTypes = {
  /**
   * children: [node] or node
   * Children nodes to render inside the <Aux> component. Can
   * be a single child or several nodes.
   */
  children: NodeOrMultipleNodes.isRequired,

  /**
   * inline: Boolean
   * Renders as inline-block element if set to true (defaults to false).
   */
  inline: PropTypes.bool,

  /**
   * className: String
   * If specified, applies a class name to the surrounding
   * container (defaults to null).
   */
  className: PropTypes.string
};

Aux.defaultProps = {
  inline: false,
  className: null
};

export default Aux;



// WEBPACK FOOTER //
// ./src/components/utility/Aux.js